export enum JoinPageStep {
  INITIAL = 'initial',
  PHONE_NUMBER = 'phone-number',
}
